import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    wrapperLoader: {
      height: 60,
      display: 'flex',
      alignItems: 'center',
    },
    loader: {
      height: 4,
      width: '100%',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: 'rgba(136, 102, 255, .21)',
      '&::before': {
        display: 'block',
        position: 'absolute',
        content: '" "',
        left: '-200px',
        width: 200,
        height: 4,
        backgroundColor: '#8866ff',
        animation: 'loading 2s linear infinite',
      },
    },
    '@keyframes loading': {
      from: { left: -200, width: '30%' },
      '50%': { width: '30%' },
      '70%': { width: '70%' },
      '80%': { left: '50%' },
      '95%': { left: '120%' },
      to: { left: '100%' },
    },
  }
})
